import { useCallback } from 'react';

type TUseConfirmationModalConfig = {
	onClose: () => void;
	onCancel?: () => void;
	isLoading: boolean;
};

type TUseConfirmationModalReturn = {
	handleOpenChange: (open: boolean) => void;
	handleCancel: () => void;
};

const useConfirmationModal = ({
	onClose,
	onCancel,
	isLoading
}: TUseConfirmationModalConfig): TUseConfirmationModalReturn => {
	const handleOpenChange = useCallback(
		(open: boolean) => {
			if (!open && !isLoading) onClose();
		},
		[isLoading, onClose]
	);

	const handleCancel = useCallback(() => {
		onCancel?.();
		onClose();
	}, [onCancel, onClose]);

	return { handleOpenChange, handleCancel };
};

export { useConfirmationModal };
